// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","icon":"Footer_icon__2fpab"};